import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { Stack, StackProps } from "@mui/material";
import { cn } from "../../../helpers/cn";

type ListingPageWrapperProps = StackProps;

export const ListingPageWrapper = ({
  className,
  children,
  ...props
}: ListingPageWrapperProps) => {
  const colors = useSelector((state: RootState) => state.theme.componentColors);

  return (
    <Stack
      sx={{
        backgroundColor: colors.surface.surface,
        backgroundImage: "none",
        padding: "1.625rem",
        borderRadius: "1.75rem",
      }}
      className={cn("space-y-[16px]", className)}
      {...props}
    >
      {children}
    </Stack>
  );
};
